import styled from "styled-components"

export const StyledNutritionRemaining = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing_l, 16px);
  color: #fff;
  z-index: 1;

  .adm-progress-bar-fill {
    min-width: 2px !important;
    border-radius: 99px;
  }
`

export const StyledNutritionItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  position: relative;

  span {
    line-height: 17px;
  }

  .loading-value {
    position: absolute;
    transition: opacity 0.2s ease-out, transform 0.2s ease-out 0.05s;
    opacity: 0;
    transform: translateX(-12px);

    &--show {
      transition: opacity 0.2s ease-out, transform 0.2s ease-in;
      opacity: 1;
      transform: translateX(-5px);
    }
  }

  .real-value {
    position: absolute;
    transition: opacity 0.2s ease-out, transform 0.2s ease-in;
    opacity: 1;
    transform: translateX(-40px);
    min-width: 40px;
    text-align: right;

    &--hidden {
      transition: opacity 0.2s ease-out 0.05, transform 0.2s ease-out;
      opacity: 0;
      transform: translateX(-15px);
    }
  }
`

export const NutritionName = styled.div`
  color: var(--Primitive-White_60, rgba(255, 255, 255, 0.6));
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 1.44px;
  text-transform: uppercase;
`

export const NutritionValue = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 160%;
  color: #fff;
  letter-spacing: 0.1px;
  height: 17px;
  line-height: 17px;
  font-weight: 700;
`

export const NutritionGoalValue = styled.div<{ $width?: string }>`
  color: #fff;
  font-size: 12px;
  line-height: 160%;
  margin-top: auto;
  height: 15px;
  line-height: 15px;
  align-self: flex-end;
  font-weight: 500;
  transition: all 0.2s ease-in-out;
  width: ${(props) => props.$width};
`

export const ProgressTrackBar = styled.div`
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  border-radius: 99px;
  background: var(--White_20, rgba(255, 255, 255, 0.2));
  height: 1px;
  width: 100%;
  z-index: 1;
`
